// feature/insumos-mega — drill-down view of an insumos user's currently-assigned cases.
// Admin/directora can reassign individual cases via a modal. Backed by the
// feature/insumos-auto-assignment endpoint GET /api/users/:id/insumos-cases.
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { users as usersApi } from "../../api/endpoints";
import Spinner from "../../components/Spinner";
import Empty from "../../components/Empty";
import ReassignModal from "../../components/ReassignModal";
import { TipoPill, EstadoPill } from "../../components/Pills";

const fmt = (d) => d ? new Date(d).toLocaleString("es-CO") : "—";

export default function UserInsumosCases() {
  const { id } = useParams();
  const userId = Number(id);
  const [data, setData] = useState(null);
  const [user, setUser] = useState(null);
  const [reassignTarget, setReassignTarget] = useState(null);

  function load() {
    setData(null);
    usersApi.insumosCases(userId).then(r => setData(r.data || [])).catch(() => setData([]));
  }
  useEffect(() => {
    load();
    usersApi.withRoles().then(r => setUser((r.data || []).find(u => u.id === userId)));
    // eslint-disable-next-line
  }, [userId]);

  return (
    <div className="col" style={{ gap: 16 }}>
      <div>
        <Link to="/admin/users" className="muted" style={{ fontSize: 12 }}>← Volver a Usuarios</Link>
        <h1 style={{ margin: "8px 0 0" }}>Casos asignados — {user?.name || user?.email || `#${userId}`}</h1>
        {user && (
          <div className="muted" style={{ marginTop: 4, fontSize: 13 }}>
            {user.email} · Hoy {user.cases_assigned_today_actual ?? 0} / {user.daily_quota ?? "—"}
            {" · "}Disponible: {user.available_for_assignment ? "Sí" : "No"}
          </div>
        )}
      </div>

      <div className="card" style={{ padding: 0 }}>
        {data == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !data.length ? (
          <Empty title="Sin casos asignados" message="Este usuario no tiene casos de insumos en este momento." />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Caso</th>
                <th>Tipo</th>
                <th>Accionante</th>
                <th>Radicado</th>
                <th>Estado</th>
                <th>Asignado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.map(c => (
                <tr key={c.id}>
                  <td><strong>{c.case_number}</strong></td>
                  <td><TipoPill tipo={c.tipo} /></td>
                  <td>{c.accionante_nombre || "—"}</td>
                  <td>{c.radicado || "—"}</td>
                  <td><EstadoPill c={c} /></td>
                  <td className="muted" style={{ fontSize: 12 }}>{fmt(c.insumos_assigned_at)}</td>
                  <td>
                    <button className="secondary sm" onClick={() => setReassignTarget(c)}>Reasignar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {reassignTarget && (
        <ReassignModal
          caseId={reassignTarget.id}
          caseNumber={reassignTarget.case_number}
          currentUserId={userId}
          onClose={() => setReassignTarget(null)}
          onSuccess={() => { setReassignTarget(null); load(); }}
        />
      )}
    </div>
  );
}
